export interface AllergenStatusLike {
  hasAllergenAnalysis?: boolean | null;
  hasAllergen?: boolean | null;
}

export type AllergenStatusVariant = "pending" | "detected" | "free";

export interface AllergenStatusMeta {
  variant: AllergenStatusVariant;
  title: string;
}

export function getAllergenStatusMeta(item: AllergenStatusLike): AllergenStatusMeta {
  if (!item.hasAllergenAnalysis) {
    return {
      variant: "pending",
      title: "Allergen analysis pending.",
    };
  }

  if (item.hasAllergen) {
    return {
      variant: "detected",
      title: "Contains allergens.",
    };
  }

  return {
    variant: "free",
    title: "Allergen-free.",
  };
}
